export default __webpack_public_path__ + "static/media/reg-modal-anim.8132c6ff.gif";